var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout-main',[_c('atom-title',{attrs:{"text":"404 !!"}}),_vm._v(" "),_c('atom-link',{attrs:{"to":_vm.isLoggedIn ? 'home' : 'sign-in',"replace":"","text":"Home"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }